import React, { useState, useEffect } from "react";
import { postRequest } from "../utils/apicalls";
import { Button, message, Modal, Input, Checkbox } from "antd";
import { ClockCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "../styles/markattendance.css";
import timelog from "../image/Time management.png";

const MarkAttendance = () => {
  const navigate = useNavigate();
  const currentTime = new Date();
  const currentHour = currentTime.getHours();
  const currentMinute = currentTime.getMinutes();

  const [currentFormattedTime, setCurrentFormattedTime] = useState(
    new Date().toLocaleTimeString()
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentFormattedTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const todayDate = new Date().toISOString().split("T")[0];

  if (localStorage.getItem("attendanceDate") !== todayDate) {
    localStorage.setItem("attendanceDate", todayDate);

    localStorage.removeItem("isTimedIn_morning");
    localStorage.removeItem("isTimedOut_morning");
    localStorage.removeItem("isTimedIn_afternoon");
    localStorage.removeItem("isTimedOut_afternoon");

    localStorage.removeItem("hasTimeInAM");
    localStorage.removeItem("hasTimeOutAM");
    localStorage.removeItem("hasTimeInPM");
    localStorage.removeItem("hasTimeOutPM");

    localStorage.removeItem("lastTimeInAM");
    localStorage.removeItem("lastTimeInPM");
  }

  const hasTimeInAM = localStorage.getItem("hasTimeInAM") === "true";
  const hasTimeOutAM = localStorage.getItem("hasTimeOutAM") === "true";

  const hasTimeInPM = localStorage.getItem("hasTimeInPM") === "true";
  const hasTimeOutPM = localStorage.getItem("hasTimeOutPM") === "true";

  // Determine session
  let session = currentHour < 13 ? "morning" : "afternoon";

  const isTimedIn =
    session === "morning"
      ? hasTimeInAM
      : session === "afternoon"
      ? hasTimeInPM
      : false;

  const isTimedOut =
    session === "morning"
      ? hasTimeOutAM
      : session === "afternoon"
      ? hasTimeOutPM
      : false;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [taskModalOpen, setTaskModalOpen] = useState(false);
  const [taskCompleted, setTaskCompleted] = useState("");
  const [isHalfDay, setIsHalfDay] = useState(false);
  const handleTimeInOut = async () => {
    // prevent double click
    if (isTimedOut || isSubmitting) return;

    // extra protection for timeout
    if (
      isTimedIn &&
      localStorage.getItem(
        `hasTimeOut${session === "morning" ? "AM" : "PM"}`
      ) === "true"
    ) {
      return;
    }

    // block timeout after immediate time in
    if (isTimedIn) {
      const lastTimeIn = localStorage.getItem(
        `lastTimeIn${session === "morning" ? "AM" : "PM"}`
      );

      if (lastTimeIn) {
        const diffMinutes = (Date.now() - parseInt(lastTimeIn)) / 1000 / 60;

        if (diffMinutes < 1) {
          message.warning("Please wait before timing out.");
          return;
        }
      }
    }
    // Show Task Completed modal for BOTH Morning and Afternoon Time Out
    if (isTimedIn) {
      setTaskModalOpen(true);
      return;
    }

    setIsSubmitting(true);

    const id = localStorage.getItem("requester");
    const company_email = localStorage.getItem("company_email");
    const token = localStorage.getItem("authToken");

    try {
      const response = await postRequest("timesheets/punch", {
        id,
        token,
        company_email,
      });

      if (response.status === "failed") {
        message.error(response.message);

        setIsSubmitting(false);
        return;
      }

      message.success(response.message);

      // TIME IN
      if (!isTimedIn) {
        localStorage.setItem(
          `lastTimeIn${session === "morning" ? "AM" : "PM"}`,
          Date.now().toString()
        );

        localStorage.setItem(
          `hasTimeIn${session === "morning" ? "AM" : "PM"}`,
          "true"
        );
      } else {
        // TIME OUT
        localStorage.setItem(
          `hasTimeOut${session === "morning" ? "AM" : "PM"}`,
          "true"
        );
      }

      setTimeout(() => {
        navigate("/intern-logs");
      }, 1500);
    } catch (error) {
      message.error("An error occurred. Please try again.");
      setIsSubmitting(false);
    }
  };

  const handleConfirmTimeOut = async () => {
    if (!taskCompleted.trim()) {
      message.error("Task Completed is required.");
      return;
    }

    setTaskModalOpen(false);
    setIsSubmitting(true);

    const id = localStorage.getItem("requester");
    const company_email = localStorage.getItem("company_email");
    const token = localStorage.getItem("authToken");

    try {
      const payload = {
        id,
        token,
        company_email,
      };

      if (session === "morning") {
        payload.am_task_completed = taskCompleted;
      } else {
        payload.pm_task_completed = taskCompleted;
      }

      const response = await postRequest("timesheets/punch", payload);

      if (response.status === "failed") {
        message.error(response.message);
        setIsSubmitting(false);
        return;
      }

      message.success(response.message);

      localStorage.setItem(
        `hasTimeOut${session === "morning" ? "AM" : "PM"}`,
        "true"
      );

      setTaskCompleted("");

      setTimeout(() => {
        navigate("/intern-logs");
      }, 1500);
    } catch (err) {
      message.error("An error occurred.");
      setIsSubmitting(false);
    }
  };

  const disableButton =
    (session === "morning" && !isTimedIn && currentHour >= 12) ||
    (session === "afternoon" &&
      !isTimedIn &&
      (currentHour > 16 || (currentHour === 16 && currentMinute >= 30))) ||
    isTimedOut;

  if (session === "none") {
    return (
      <div className="log-overlay-container">
        <div className="log-box-container">
          <img src={timelog} alt="logo" className="log-attendance-image" />

          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={() => navigate(-1)}
            className="close-button"
          />

          <div className="clock-display">
            <ClockCircleOutlined
              style={{
                marginRight: 8,
                fontSize: "1.6em",
              }}
            />

            <strong className="log-current-time">{currentFormattedTime}</strong>
          </div>

          <p className="session-class">You have completed this session.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="log-overlay-container">
      <div className="log-box-container">
        <img src={timelog} alt="logo" className="log-attendance-image" />

        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={() => navigate(-1)}
          className="close-button"
        />

        <div className="clock-display">
          <ClockCircleOutlined
            style={{
              marginRight: 8,
              fontSize: "1.6em",
            }}
          />

          <strong className="log-current-time">{currentFormattedTime}</strong>
        </div>

        <div className="time-section">
          <h3 className="session-class">
            {session.charAt(0).toUpperCase() + session.slice(1)} Session
          </h3>

          <div className="time-buttons">
            <Button
              type={isTimedIn ? "default" : "primary"}
              onClick={handleTimeInOut}
              disabled={
                disableButton || isSubmitting || (isTimedIn && isTimedOut)
              }
              loading={isSubmitting}
            >
              {isTimedOut
                ? "Session Completed"
                : isTimedIn
                ? "Time Out"
                : "Time In"}
            </Button>
          </div>
        </div>
        <Modal
          title={`${
            session.charAt(0).toUpperCase() + session.slice(1)
          } Task Completed`}
          open={taskModalOpen}
          onCancel={() => {
            setTaskModalOpen(false);
            setTaskCompleted("");
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setTaskModalOpen(false);
                setTaskCompleted("");
              }}
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={isSubmitting}
              onClick={handleConfirmTimeOut}
            >
              Confirm Time Out
            </Button>,
          ]}
        >
          <Input.TextArea
            rows={4}
            placeholder={`Enter the tasks you completed during the ${session} session.`}
            value={taskCompleted}
            onChange={(e) => setTaskCompleted(e.target.value)}
          />
        </Modal>
      </div>
    </div>
  );
};

export default MarkAttendance;
